<div
  class="login"
  [class.is-open]="isOpen()"
  [class.is-loading]="isLoading()"
  (click)="handleOverlayClick()"
  (keydown.enter)="$event.stopPropagation()"
>
  <div class="login__overlay" #loginOverlay></div>

  <div class="login__container" #loginContainer (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()">
    <button class="login__close" aria-label="Close" (click)="handleCloseClick()">
      <img src="icons/close-icon.svg" alt="Close" width="32" height="32" loading="lazy" />
    </button>

    <div class="login__skeleton" [class.hidden]="hasReceivedResize()" aria-hidden="true">
      <div class="login__skeleton-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" stroke-dasharray="4 2"/>
        </svg>
      </div>
      <div class="login__skeleton-bar"></div>
      <div class="login__skeleton-bar login__skeleton-bar--short"></div>
    </div>

    <iframe
      #loginIframe
      class="login__iframe"
      [attr.title]="'Login'"
      (load)="onIframeLoad()"
      appIframeResize
    ></iframe>
  </div>
</div>

<!-- Snackbar -->
<div
  class="login__snackbar"
  [class.is-active]="showSnackbar()"
  [class.is-hiding]="!showSnackbar()"
  [attr.hidden]="!showSnackbar() ? '' : null"
  (click)="$event.stopPropagation()"
  (keydown.enter)="$event.stopPropagation()"
>
  <div class="snackbar__icon">
    <svg class="snackbar__icon-warning" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <svg class="snackbar__icon-close-circle" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="2"/>
      <path d="M15 9L9 15M9 9L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
  <span class="snackbar__message">Percobaan masuk belum berhasil. Silakan coba kembali.</span>
  <button class="snackbar__close" aria-label="Close" (click)="hideSnackbar()">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
</div>
